// 兼容IE11
if (!FileReader.prototype.readAsBinaryString) {
  FileReader.prototype.readAsBinaryString = function (fileData) {
    var binary = ''
    var pt = this
    var reader = new FileReader()
    reader.onload = function () {
      var bytes = new Uint8Array(reader.result)
      var length = bytes.byteLength
      for (var i = 0; i < length; i++) {
        binary += String.fromCharCode(bytes[i])
      }
      // pt.result  - readonly so assign binary
      pt.content = binary
      pt.onload()
    }
    reader.readAsArrayBuffer(fileData)
  }
}

const id = 'invisible_file_input'
const pickFile = async (options) => {
  let input = document.querySelector(`#${id}`)
  if (!input) {
    input = document.createElement('input')
    input.setAttribute('type', 'file')
    input.setAttribute('id', id)
    if (options && options.filters) {
      input.setAttribute('accept', options.filters)
    }
    if (options && options.multiple) {
      input.setAttribute('multiple', true)
    }
    input.style.display = 'none'
  }
  return await new Promise((resolve) => {
    input.onchange = () => {
      resolve(options.multiple ? input.files : input.files[0])
    }
    input.click()
  })
}

export default {
  install: (Vue) => {
    Vue.prototype.$file = {
      pickFile,
    }
  }
}
